import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Layout from '../src/components/Layout';
import { getHeader, getFooter } from '../src/adapters/contentful.adapter';
import Coupon from '../src/components/CouponCampaign/couponlp';
import { storageGet, storageSet } from '../src/helpers/StorageEvents';

const WelciaCouponCampaign = (props) => {
    const { header, footer, couponData, pageInfo } = props;
    let retailerUrl = '';

    // Below are the Encrypted mapping of Coupon Campaign Banner URLs.

    // retailer~cocokara-doubleoptin = pEQ2t~cUvy9f-dBlpTin
    // retailer~tomods-doubleoptin = pEQ2t~tNzcR9-dBlpTin
    // retailer~life-doubleoptin = pEQ2t~ldx4bG-dBlpTin
    // whisperedm-doubleoptin = wSKE2-dBlpTin
    // linead~cocokara-doubleoptin = lspP6~cUvy9f-dBlpTin
    // linead~tomods-doubleoptin = lspP6~tNzcR9-dBlpTin

    const urlMapping = {
        // // for sundrug
        // 'fbsundrug':'s5trg~fn7rk-dBlpTin',
        // 'ydasundrug': 's5trg~y8gda-dBlpTin',
        // 'edmsundrug': 's5trg~e1y6m-dBlpTin',
        // for welcia
        'fbwelcia': 'w3lca~fn7rk-dBlpTin',
        'ydawelcia': 'w3lca~y8gda-dBlpTin',
        'edmwelcia': 'w3lca~e1y6m-dBlpTin',
        'semwelcia': 'w3lca~s3e1m-dBlpTin',
        // 'whisperedmc': 'wSKE2-dBlpTin',
        // 'lineadcocokara': 'lspP6~cUvy9f-dBlpTin',
        // 'lineadtomods': 'lspP6~tNzcR9-dBlpTin',
        // 'fb': 'fcI2Q-dBlpTin',
        // 'gdn': 'gPtdN-dBlpTin',
        // 'whisperedmcode': 'bSqE8-dBlpTin',
        // 'facebook': 'ftq2k-dBlpTin',
        // 'welcia': 'wl1ba-dBlpTin',
        // 'whispertoppagemenu': 'we2pm-dBlpTin',
    };

    useEffect(() => {
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const isAdBannerTypeAvailable = storageGet('adBannerType');

        if (!isAdBannerTypeAvailable) {
            const adBanner = params.get('adbanner');
            const banner = params.get('banner');
            retailerUrl = banner ? urlMapping[`${adBanner}${banner}`] : urlMapping[`${adBanner}`];
            if (!retailerUrl) {
                Router.push('/');
            }
            storageSet('retailerUrl', retailerUrl);
        }
    });

    return (
        <div>
            <Layout header={header} footer={footer} pageInfo={pageInfo}>
                <div className="content-wrapper coupon-campaign">
                    <Coupon couponData={couponData} />
                    <div id="mw-campaign">get-my-free-sample</div>
                </div>
            </Layout>
        </div>
    );
};

WelciaCouponCampaign.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();

    return {
        header,
        footer,
        pageInfo: {
            breadcrumbsTitle: 'ウエルシアキャンペーン',
            title: 'ウィスパー×ウエルシアキャンペーン【全員もらえます】',
            description:
            'ウィスパー購入時にクーポンバーコード提示で200円OFF！カンタンな登録・サインインでお得なクーポンを獲得できます。',
            url: '/ウィスパー新発売記念キャンペーン',
            ogTitle: 'ウィスパー×ウエルシアキャンペーン【全員もらえます】',
            ogType: 'website',
            ogDescription:
                'ウィスパー購入時にクーポンバーコード提示で200円OFF！カンタンな登録・サインインでお得なクーポンを獲得できます。',

            ogImage: {
                url:
                    'https://images.ctfassets.net/8g0fie    vzqg8k/1xYSc0d2UTlal28HNKCF5S/f2454808263615cb9d7944c6025f6137/KOI_OPG_kv.jpg',
                width: 1201,
                height: 631,
                contentType: 'image/jpeg',
            },
            canonicals: {
                items: [{ canonical: 'https://whisper.jp/welcia-lp1/' }],
            },
        },
    };
};

WelciaCouponCampaign.propTypes = {
    footer: PropTypes.object,
    header: PropTypes.object,
    couponData: PropTypes.object,
    pageInfo: PropTypes.object,
};

export default WelciaCouponCampaign;
